import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReplaceSmartPunctuationDirective } from './replace-smart-punctuation.directive';

@NgModule({
  imports: [CommonModule],
  declarations: [ReplaceSmartPunctuationDirective],
  exports: [ReplaceSmartPunctuationDirective],
})
export class ReplaceSmartPunctuationModule {}
